<template>
  <div class="explain">
    <a class="close" @click="close">返回</a>
    <img src="@/assets/images/explain.jpg" alt="抽奖说明" />
    <a href="http://m.eicchannel.com" class="exp-btn">首页</a>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {},
  methods: {
    close() {
      if (window.location.hostname == "m.eicchannel.com") {
        window.location.href =
          "http://m.eicchannel.com/special/expo_business_202104_m/#prize";
      } else if (window.location.hostname == "m0.eicchannel.com") {
        window.location.href =
          "http://m0.eicchannel.com/special/expo_business_202104_m/#prize";
      } else {
        this.$router.go(-1);
      }
    },
  },
  mounted() {
    window.scrollTo(0, 0)
  },
};
</script>

<style scoped>
.explain {
  /* background-color: #2953ce; */
}
.explain .close {
  display: block;
  width: 2rem;
  height: 1rem;
  position: absolute;
  left: 0;
  top: 0;
  text-indent: -9999px;
}
.exp-btn {
  display: block;
  width: 6rem;
  height: 1rem;
  position: absolute;
  left: 0.8rem;
  top: 16.9rem;
  text-indent: -9999px;
}
</style>
